<div class="login-page" style="display: block; align-content: space-evenly;justify-self: center;">
    <div>
      <h1>⚠️ Unauthorized</h1>
      </div>
    <br />
      <p style="margin: 1rem 0;">You don't have permission to view this page.</p>
      <div style="display: inline-flex;">
          <button class="btn btn-md btn-outline-gray" (click)="goBack()">Go Back</button>&nbsp;
          <button class="btn btn-md btn-primary" (click)="logout()">Log out</button>
      </div>

</div>
